import {useMagnoliaFetch} from "#magnolia-layer/composables/use-magnolia-fetch";
import type {Category} from "#magnolia-layer/types/magnolia-types";

export const useCategoriesByPath = async (path: string): Promise<Category[] | undefined> => {
  if (path === '') {
    return undefined;
  }

  const runtimeConfig = useRuntimeConfig();
  const apiUrl = `${runtimeConfig.public.mgnl.apiCategories}${path}/@nodes`;
  const {data: content, error} = await useMagnoliaFetch<Category[]>(
      apiUrl
  );
  if (content.value && content.value.length > 0) {
    return content.value;
  }
  return undefined;
};
